module.exports = __webpack_public_path__ + "static/assets/5db42d093b79f63ad14670ec630059ea.svg";